import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupEventSubjectConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupEventSubjectConditionsForm';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import styles from './PassportGroupDetailEventSubjectConditions.module.scss';
import { PassportGroupPassportTypeEnum } from '../PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';

interface IPassportGroupDetailEventSubjectConditionsProps {
  condition: IGroupEventSubjectConditionsForm | undefined;
  category: PassportGroupPassportTypeEnum | undefined;
}

export const PassportGroupDetailEventSubjectConditions = ({
  condition,
  category,
}: IPassportGroupDetailEventSubjectConditionsProps) => {
  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Предмет мероприятия">
      <>
        {!!condition.requirements?.length && (
          <FieldBlock
            label={
              category === PassportGroupPassportTypeEnum.DECISION_PASSPORT
                ? 'Выявленные нарушения обязательных требований'
                : 'Обязательные требования, подлежащие проверке'
            }
            margin="bottom"
          >
            {condition.requirements.map((item, index) => (
              <KnmCollapse
                title={
                  <>
                    <span className={styles.CollapseTitleGrey}>НПА №</span>
                    {item.npa?.number}
                    <span className={styles.CollapseTitleGrey}>от</span>
                    {item.npa?.acceptanceDate}
                  </>
                }
                theme="fields"
                key={index}
              >
                <>
                  <div className={styles.NpaName}>{item.npa?.title}</div>
                  {!!item.structuralUnits?.length && (
                    <div className={styles.StructureUnitTitle}>
                      <span>Структурные единицы</span>
                    </div>
                  )}
                  {item.structuralUnits?.map((suItem, suIndex) => (
                    <div key={suIndex}>
                      <div className={styles.SuItemWrapper}>
                        <div>{suIndex + 1}</div>
                        <div>{suItem.structuralUnit.title}</div>
                      </div>
                      {suItem.mandatory?.map((mItem, mIndex) => (
                        <div key={mIndex} className={styles.MandatoryBlock}>
                          <div>Содержание требования</div>
                          <div>{mItem.title}</div>
                        </div>
                      ))}
                    </div>
                  ))}
                </>
              </KnmCollapse>
            ))}
          </FieldBlock>
        )}
        {!!condition.docTargets?.length && (
          <FieldBlock label="Разрешительные и иные документы" margin="bottom">
            <SelectInput value={condition.docTargets} isMulti disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
